import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";

const ImageButtonSection = ({ image, altText, id, heading, description, onShare }) => {
  const location = useLocation();
  const isSpecialPage = location.pathname === "/collection";

  const handleDownload = useCallback(() => {
    if (!image) {
      console.error("Image URL is undefined! Cannot download.");
      return;
    }

    const safeAltText = altText ? altText.replace(/[^a-zA-Z0-9]/g, "_") : "downloaded_image";

    // Notify user about the wait time
    alert("Downloading Start. Please wait...");

    setTimeout(() => {
      try {
        const link = document.createElement("a");
        link.href = image;
        link.setAttribute("download", `${safeAltText}.jpg`); // Ensuring valid filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        alert("Download Completed!");
      } catch (error) {
        console.error("Download failed:", error);
      }
    }, 10000); // 1 seconds delay

  }, [image, altText]);

  return (
    <section className={`snapseed ${isSpecialPage ? "special-page" : ""}`}>
      {/* Heading and Description */}
      <div className="image-text">
        {/* <h2 className="image-heading">{heading}</h2> */}
        <p className="section-description">
        <strong>{id}.</strong> {description}
        </p>
      </div>

      {/* Image */}
      <img src={image} alt={altText || "Image"} className="showcase-image" loading="lazy" />

      {/* Buttons */}
      {!isSpecialPage && (
        <div className="button-container">
          <button className="app download-button" onClick={handleDownload}>
            Download Now
          </button>
          <button className="app share-button" onClick={onShare}>
            Share
          </button>
        </div>
      )}
    </section>
  );
};

export default React.memo(ImageButtonSection);
